<div class="app-content content bg-blue1">
    <div class="content-wrapper">
        <div class="content-header row">
        </div>
      <div class="content-body">
        <section id="contact" class="contact section-bg">
            <div class="row">
                <div class="col-lg-6">           
                    <div class="card">
                        <div class="card-body">
                            <div class="row text-center">
                                <div class="fonticon-wrap"><i class="feather ft-map-pin icon"></i></div>
                            </div>
                            <br>
                            <h2 class="text-center text-bold-500 font-large-1">{{'TXT_LOCATION' | translate}}</h2>
                            <hr>
                            <h3 class="text-center card-title font-medium-5">Universidad Tecnológica de Puebla
                                <br>Edificio Docencia No-5 - División de Tecnologías de la Información 
                            </h3>
                            <h4 class="text-center card-title font-medium-3">Antiguo Camino a La Resurrección 1002 - A, Zona Industrial, 72300 Puebla, Pue.</h4>                          
                        </div>
                    </div>
                </div>

                <div class="col-lg-6">             
                    <div class="card">
                        <div class="card-body">
                            <div class="row text-center">
                                <div class="fonticon-wrap"> <i class="feather ft-clock icon"></i></div>
                            </div>
                            <br>
                            <h2 class="text-center text-center text-bold-500 font-large-1">{{'TXT_HOUR' | translate}}</h2>
                            <hr>
                            <h3 class="text-center card-title font-medium-5">9:00 - 18:00 horas</h3>
                            <h4 class="text-center card-title font-medium-3">{{'TXT_DAYS' | translate}}</h4>                          
                        </div>
                    </div>
                </div>               
            </div>
            
            <div class="row">
                <div class="col-lg-6"> 
                    <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15084.486727812488!2d-98.1519509!3d19.0583869!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0xefd33e2f1a6ca5a2!2sUniversidad%20Tecnol%C3%B3gica%20de%20Puebla!5e0!3m2!1ses!2smx!4v1677194930108!5m2!1ses!2smx" frameborder="0" style="border:0; width: 100%; height: 384px;" allowfullscreen=""></iframe>
                </div>
                <div class="col-lg-3 col-md-6">             
                    <div class="card">
                        <div class="card-body">
                            <div class="row text-center">
                                <div class="fonticon-wrap"><i class="feather ft-phone icon"></i></div>
                            </div>
                            <br>
                            <h2 class="text-center text-center text-bold-500 font-large-1">{{'TXT_PHONES' | translate}}</h2>
                            <hr>
                            <h3 class="text-center card-title font-medium-5">222 309 8861 Ext. 2161
                                <br>222 309 8870 Ext. 2170
                            </h3>                          
                        </div>
                    </div>
                </div>
                <div class="col-lg-3 col-md-6">             
                    <div class="card">
                        <div class="card-body">
                            <div class="row text-center">
                                <div class="fonticon-wrap"> <i class="feather ft-mail icon"></i></div>
                            </div>
                            <br>
                            <h2 class="text-center text-center text-bold-500 font-large-1">{{'TXT_UTPMAIL' | translate}}</h2>
                            <hr>
                            <h3 class="text-center card-title font-medium-5">direccion.tic@utpuebla.edu.mx</h3>                          
                        </div>
                    </div>
                </div>
            </div>

            <div class="row"><br><br><br><br><br></div>                             
        </section>         
        </div>
      </div>
    </div>

